import { Fragment, type ReactNode } from 'react';
import { useView } from '../../contexts/ViewContext';

interface ViewScopedProps {
  children: ReactNode;
}

/**
 * Remounts a page when the top view switcher moves to another group, region
 * or division.
 *
 * For pages that load once on mount and take their scope from the saved view.
 * The switcher saves the new view before it changes ``viewKey``, so the
 * remounted page reads the new scope.
 *
 * @example
 * <ViewScoped><CallOffPerformance /></ViewScoped>
 *
 * @param children - The page to reload on a switch
 * @returns The page, keyed to the current view
 */
export default function ViewScoped({ children }: ViewScopedProps) {
  const { viewKey } = useView();
  return <Fragment key={viewKey}>{children}</Fragment>;
}
